import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import InsetContainer from 'components/common/containers/inset_container';
import InlineContainer from 'components/common/containers/inline_container';
import LoadingSpinner from 'components/lib/loading_spinner';
import SearchInput from 'components/common/search_input';
import TeamsProvider from 'components/admin/users/teams_provider';
import UsersTable from 'components/admin/users/users_table';

import {
  DeleteTeamIcon,
  EditTeamHeader,
  PendingSpinnerWrapper,
  SearchInputWrapper,
  Users,
} from 'components/admin/users/team_editor/team_editor_components';

export default class SelectableUsersTable extends React.Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['handleChangeTextFilter', 'handleClearTextFilter']);

    this.state = {
      textFilter: '',
    };
  }

  handleChangeTextFilter(evt) {
    this.setState({ textFilter: evt.target.value });
  }

  handleClearTextFilter() {
    this.setState({ textFilter: '' });
  }

  render() {
    return (
      <Users>
        <InsetContainer inset="large">
          <EditTeamHeader data-aid="teamEditor-header">
            <InlineContainer as="span" inset="none">
              <span>{this.props.isNewTeam ? 'Create a team' : 'Edit'}</span>
              {this.renderDeleteIcon()}
            </InlineContainer>
          </EditTeamHeader>
          <SearchInputWrapper>
            <SearchInput
              autoFocus
              initialValue={this.state.textFilter}
              onChange={this.handleChangeTextFilter}
              onClearText={this.handleClearTextFilter}
              placeholder="Search for an agent"
            />
          </SearchInputWrapper>
        </InsetContainer>
        <TeamsProvider>
          <UsersTable
            inset="none"
            canSelectUsers
            selectedUserIds={this.props.selectedUserIds}
            textFilter={this.state.textFilter}
            onUserSelectClick={this.props.onUserSelectClick}
          />
        </TeamsProvider>
      </Users>
    );
  }

  renderDeleteIcon() {
    if (this.props.isNewTeam) {
      return null;
    }
    if (this.props.isPendingDelete) {
      return (
        <PendingSpinnerWrapper className="teamDeleteSpinner">
          <LoadingSpinner containerClassName="teamDeleteSpinner" position="relative" size="16px" />
        </PendingSpinnerWrapper>
      );
    }
    return (
      <DeleteTeamIcon
        className={classnames({ disabled: this.props.isPendingSave })}
        data-aid="teamEditor-delete-icon"
        onClick={this.props.openDeleteTeamModal}
      />
    );
  }
}

SelectableUsersTable.propTypes = {
  isNewTeam: PropTypes.bool,
  isPendingDelete: PropTypes.bool,
  isPendingSave: PropTypes.bool,
  onUserSelectClick: PropTypes.func,
  openDeleteTeamModal: PropTypes.func,
  selectedUserIds: PropTypes.arrayOf(String),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_editor/selectable_users_table.jsx